<template>
  <div class="box">
    <div class="main-content">
      <!-- 选择器部分开始 -->
      <div class="flex">
        <!-- 班级选择器 -->
        <div class="flex align">
          <div class="selector-txt">班级</div>
          <el-cascader ref="classSelector" @change="classHandleChange" v-model="classValue"
            :options="classOptions"></el-cascader>
        </div>
        <!-- 姓名选择器 -->
        <div class="flex align" style="margin-left: 50px">
          <div class="selector-txt">姓名</div>
          <el-select @change="nameHandleChange" filterable v-model="nameValue" placeholder="请选择">
            <el-option v-for="item in nameOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 日期选择器 -->
        <div class="flex align" style="margin-left: 50px">
          <div class="selector-txt">日期</div>
          <el-date-picker @change="dateHandleChange" :default-time="['00:00:00', '23:59:59']" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss" v-model="dateValue" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
        </div>
      </div>
      <!-- 选择器部分结束 -->
      <!-- echart图表部分开始 -->
      <div class="flex" style="margin-top: 30px">
        <echartsPie :preData="preData[0]"></echartsPie>
        <echartsPie style="margin-left: 147px" :preData="preData[1]"></echartsPie>
      </div>
      <!-- echart图表部分结束 -->
      <div class="flex spaceBetween" style="margin-top: 34px">
        <div></div>
        <div class="flex">
          <img @click="btnPointsDetails" class="btnPointsDetails" src="@/assets/viewPoints/iconPointsDetails.png" />
          <img v-show="editableOrNot" @click="btnPercentageOfPoints" class="btnPercentageOfPoints"
            src="@/assets/viewPoints/iconPercentageOfPoints.png" />
          <img @click="btnDataExport" class="btnDataExport" src="@/assets/viewPoints/iconDataExport.png" />
        </div>
      </div>
      <!-- 学生表格部分开始 -->
      <el-table :data="studentDataList" style="margin-top: 14px"
        :header-cell-style="{ background: '#EEEEEE', color: '#000000' }" stripe border height="calc(100vh - 405px)">
        <el-table-column align="center" prop="name" label="学生姓名"> </el-table-column>
        <el-table-column align="center" prop="account" label="学号"> </el-table-column>
        <el-table-column align="center" prop="grade" label="年级"> </el-table-column>
        <el-table-column align="center" prop="class" label="班级"> </el-table-column>
        <el-table-column align="center" prop="coursePoints" label="课程积分">
          <template slot-scope="scope"> {{ scope.row.coursePoints }}分 </template>
        </el-table-column>
        <el-table-column align="center" prop="performanceScore" label="平时表现分">
          <template slot-scope="scope"> {{ scope.row.performanceScore }}分 </template>
        </el-table-column>
        <el-table-column align="center" prop="midtermExamScore" label="期中考试分数">
          <template slot-scope="scope"> {{ scope.row.midtermExamScore }}分 </template>
        </el-table-column>
        <el-table-column align="center" prop="finalExamScore" label="期末考试分数">
          <template slot-scope="scope"> {{ scope.row.finalExamScore }}分 </template>
        </el-table-column>
        <el-table-column align="center" prop="otherExamScore" label="其他考试分数">
          <template slot-scope="scope"> {{ scope.row.otherExamScore }}分 </template>
        </el-table-column>
        <el-table-column align="center" prop="totalScore" label="总评分">
          <template slot-scope="scope"> {{ parseFloat(scope.row.totalScore.toFixed(1)) }}分 </template>
        </el-table-column>
      </el-table>
      <!-- 学生表格部分结束 -->
    </div>
    <!-- 各分值占比设置弹窗部分开始 -->
    <div v-show="showPercentageOfPoints" class="popup-percentageOfPoints flex align justify">
      <div class="percentageOfPoints-content flex column spaceBetween">
        <div>
          <img @click="showPercentageOfPoints = false" class="btnClose pointer" src="../../assets/btnClose.png" />
          <div class="percentageOfPoints-title">各分值占比设置</div>
          <div class="percentageOfPoints-box flex">
            <div class="percentageOfPoints-setupBox" style="border-radius: 10px 0 0 10px">
              <div class="percentageOfPoints-setupTitle" style="border-radius: 10px 0 0 0">课程积分占比</div>
              <div class="percentageOfPoints-setup">
                <el-input-number :min="0" :max="maximum1" size="mini"
                  v-model="proportionOfCoursePoints"></el-input-number>
              </div>
            </div>
            <div class="percentageOfPoints-setupBox">
              <div class="percentageOfPoints-setupTitle">平时表现分占比</div>
              <div class="percentageOfPoints-setup">
                <el-input-number :min="0" :max="maximum2" size="mini" v-model="performancePercentage"></el-input-number>
              </div>
            </div>
            <div class="percentageOfPoints-setupBox">
              <div class="percentageOfPoints-setupTitle">期中考试占比</div>
              <div class="percentageOfPoints-setup">
                <el-input-number :min="0" :max="maximum3" size="mini"
                  v-model="proportionOfMidtermExams"></el-input-number>
              </div>
            </div>
            <div class="percentageOfPoints-setupBox">
              <div class="percentageOfPoints-setupTitle">期末考试占比</div>
              <div class="percentageOfPoints-setup">
                <el-input-number :min="0" :max="maximum4" size="mini"
                  v-model="proportionOfFinalExams"></el-input-number>
              </div>
            </div>
            <div class="percentageOfPoints-setupBox" style="border-radius: 0 10px 10px 0">
              <div class="percentageOfPoints-setupTitle" style="border-radius: 0 10px 0 0">其他考试占比</div>
              <div class="percentageOfPoints-setup">
                <el-input-number :min="0" :max="maximum5" size="mini" v-model="otherPercentage"></el-input-number>
              </div>
            </div>
          </div>
        </div>
        <!-- 确认按钮 -->
        <div class="flex justify pointer">
          <div @click="btnConfirm" class="btnConfirm">确认</div>
        </div>
      </div>
    </div>
    <!-- 各分值占比设置弹窗部分结束 -->
  </div>
</template>

<script>
import { myCourseGet, getStudentScore, getClassScore, scorePercentageSetting, getScoreList, obtainTeacherTeachingClass } from "@/api";
import echartsPie from "@/components/echarts_pie";
import { Toast } from "vant";
export default {
  data() {
    return {
      editableOrNot: true, // 是否可编辑
      classOptions: [], // 班级选项
      classValue: ["2021级", 1], // 默认班级
      teachingClass: [], // 老师授课班级
      currentGrade: "", // 当前年级
      currentClass: "", // 当前班级
      classNumberValue: 0, // 默认课次
      dateValue: [], // 默认日期
      nameOptions: [], // 姓名选项
      nameValue: "", // 默认姓名
      studentDataList: [], // 学生表格数据
      showPercentageOfPoints: false, // 是否展示各分值占比设置弹窗
      proportionOfCoursePoints: 25, // 课程积分占比
      performancePercentage: 25, // 平时表现分占比
      proportionOfMidtermExams: 25, // 期中考试占比
      proportionOfFinalExams: 25, // 期末考试占比
      otherPercentage: 25, // 其他考试占比
      maximum1: 100, // 最大值
      maximum2: 100, // 最大值
      maximum3: 100, // 最大值
      maximum4: 100, // 最大值
      maximum5: 100, // 最大值
      scoreList: [], // 表现分、期中考试分数、期末考试分数列表
      averageScore: 0, // 计算平均分
      classId: 0, // 班级id
      // echart的数据
      preData: [
        {
          title: "总评分统计",
          show: true,
          typeList: [
            { value: 0, name: "0～59分" },
            { value: 0, name: "60～69分" },
            { value: 0, name: "70～79分" },
            { value: 0, name: "80～89分" },
            { value: 0, name: "90～100分" },
          ],
          countLength: "{totalText|平均分}" + "\n" + "{totalText|" + 0 + "分}",
        },
        {
          title: "优良率统计",
          show: true,
          typeList: [
            { value: 0, name: "不及格" },
            { value: 0, name: "一般" },
            { value: 0, name: "中等" },
            { value: 0, name: "良好" },
            { value: 0, name: "优秀" },
          ],
          countLength: "{totalText|及格率}" + "\n" + "{totalText|" + 0 + "%}",
        },
      ],
    };
  },
  watch: {
    // 监听课程积分占比
    proportionOfCoursePoints: {
      handler(val, oldVal) {
        this.proportionOfCoursePoints = val;
        this.publicUpdateProportion();
      },
    },
    // 监听平时表现分占比
    performancePercentage: {
      handler(val, oldVal) {
        this.performancePercentage = val;
        this.publicUpdateProportion();
      },
    },
    // 监听期中考试占比
    proportionOfMidtermExams: {
      handler(val, oldVal) {
        this.proportionOfMidtermExams = val;
        this.publicUpdateProportion();
      },
    },
    // 监听期末考试占比
    proportionOfFinalExams: {
      handler(val, oldVal) {
        this.proportionOfFinalExams = val;
        this.publicUpdateProportion();
      },
    },
    // 监听期末考试占比
    otherPercentage: {
      handler(val, oldVal) {
        this.otherPercentage = val;
        this.publicUpdateProportion();
      },
    },
  },
  components: { echartsPie },
  created() {
    this.editableOrNot = this.$store.state.editableOrNot; // 获取是否可编辑状态
    // 调用获取课程详情接口获取各分值占比设置
    let params = {
      where: [{ k: "id", v: this.$store.state.courseDetails.id, op: "=" }],
    };
    myCourseGet(params).then((res) => {
      this.proportionOfCoursePoints = res.data.datas.percent_lesson; // 获取课程积分占比
      this.performancePercentage = res.data.datas.percent_active; // 获取平时表现分占比
      this.proportionOfMidtermExams = res.data.datas.percent_middle; // 获取期中考试占比
      this.proportionOfFinalExams = res.data.datas.percent_back; // 获取期末考试占比
      this.otherPercentage = res.data.datas.percent_other; // 获取其他考试占比
    });
    // 调用获取老师授课班级列表接口
    let params1 = { lesson_id: this.$store.state.courseDetails.id };
    obtainTeacherTeachingClass(params1).then((res) => {
      this.teachingClass = res.data.datas; // 获取老师所有授课班级
      this.currentGrade = res.data.datas[0].grade; // 获取当前年级
      this.currentClass = res.data.datas[0].name; // 获取当前班级
      let groupedData = res.data.datas.reduce((groups, item) => {
        (groups[item.grade] = groups[item.grade] || []).push(item);
        return groups;
      }, {});
      this.classValue[0] = res.data.datas[0].grade;
      this.classValue[1] = res.data.datas[0].id;
      this.classId = res.data.datas[0].id;
      // 调用获取表现分、期中考试分数、期末考试分数列表接口
      let params2 = { where: [{ k: "class_id", v: this.classId, op: "=" }] };
      getScoreList(params2).then((res) => {
        if (res.data.code == 0) {
          this.scoreList = res.data.datas;
        }
      });
      for (let key in groupedData) {
        for (let j in groupedData[key]) {
          let publicRes = groupedData[key];
          publicRes[j].value = publicRes[j].id;
          publicRes[j].label = publicRes[j].name;
        }
        this.classOptions.push({
          value: key,
          label: key,
          children: groupedData[key],
        });
      }
      // 调用获取数据方法
      this.publicGettingDataFunc();
    });
    this.dateValue[0] = this.getCurrentSemesterStart();
    this.dateValue[1] = this.formatDate(new Date());
  },
  methods: {
    // 更新分值占比
    publicUpdateProportion() {
      let score1 = this.proportionOfCoursePoints;
      let score2 = this.performancePercentage;
      let score3 = this.proportionOfMidtermExams;
      let score4 = this.proportionOfFinalExams;
      let score5 = this.otherPercentage;
      this.maximum1 = 100 - score2 - score3 - score4 - score5;
      this.maximum2 = 100 - score1 - score3 - score4 - score5;
      this.maximum3 = 100 - score1 - score2 - score4 - score5;
      this.maximum4 = 100 - score1 - score2 - score3 - score5;
      this.maximum5 = 100 - score1 - score2 - score3 - score4;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份补0
      const day = String(date.getDate()).padStart(2, "0"); // 日期补0
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getCurrentSemesterStart() {
      const now = new Date();
      const year = now.getFullYear();
      // 判断当前是春季还是秋季学期
      if (now.getMonth() >= 2 && now.getMonth() <= 7) {
        // 3月~8月是春季学期
        return this.formatDate(new Date(year, 2, 1)); // 3月1日（月份从0开始计数）
      } else {
        // 如果当前是1-2月，则属于去年的秋季学期
        const isFirstHalfOfYear = now.getMonth() <= 1;
        return this.formatDate(new Date(isFirstHalfOfYear ? year - 1 : year, 8, 1)); // 9月1日
      }
    },
    // 保留小数 value:值 n:保留位数
    roundFun(value, n) {
      return Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
    },
    // handleChange1(value) {
    //   console.log(value, "进入");
    //   let score1 = this.proportionOfCoursePoints;
    //   let score2 = this.performancePercentage;
    //   let score3 = this.proportionOfMidtermExams;
    //   let score4 = this.proportionOfFinalExams;
    //   this.maximum1 = 100 - score2 - score3 - score4;
    // },
    // handleChange2(value) {
    //   let score1 = this.proportionOfCoursePoints;
    //   let score2 = this.performancePercentage;
    //   let score3 = this.proportionOfMidtermExams;
    //   let score4 = this.proportionOfFinalExams;
    //   this.maximum2 = 100 - score1 - score3 - score4;
    // },
    // handleChange3(value) {
    //   let score1 = this.proportionOfCoursePoints;
    //   let score2 = this.performancePercentage;
    //   let score3 = this.proportionOfMidtermExams;
    //   let score4 = this.proportionOfFinalExams;
    //   this.maximum3 = 100 - score1 - score2 - score4;
    // },
    // handleChange4(value) {
    //   let score1 = this.proportionOfCoursePoints;
    //   let score2 = this.performancePercentage;
    //   let score3 = this.proportionOfMidtermExams;
    //   let score4 = this.proportionOfFinalExams;
    //   this.maximum4 = 100 - score1 - score2 - score3;
    // },
    // 获取学生评分数据
    publicGettingDataFunc() {
      this.nameOptions = []; // 清空姓名选择器数据
      this.studentDataList = []; // 清空学生数据列表数据
      // 调用获取评分统计接口
      let data = { class_id: this.classId, lesson_id: this.$store.state.courseDetails.id, begin: this.dateValue[0], end: this.dateValue[1] };
      getStudentScore(data).then((res) => {
        let scoreData = res.data.datas; // 学生评分数据
        let studentList = scoreData.users; //学生列表
        let studentTable = {}; // 学生表格数据
        for (let i = 0; i < studentList.length; i++) {
          // 获取姓名选择器数据
          this.nameOptions.push({
            value: studentList[i].name,
            label: studentList[i].name,
          });
          let { account, name, id } = studentList[i];
          studentTable[id] = { name, account, grade: this.currentGrade, class: this.currentClass, coursePoints: 0, performanceScore: 0, midtermExamScore: 0, finalExamScore: 0, otherExamScore: 0, totalScore: 0 };
        }
        // 计算课程积分
        console.log(scoreData, "课程总积分");
        scoreData?.lesson_score?.forEach(({ score, user_id }) => {
          studentTable[user_id].coursePoints = this.roundFun((score / scoreData.lesson_total_score) * this.proportionOfCoursePoints, 1) || 0;
          studentTable[user_id].totalScore = studentTable[user_id].coursePoints;
        });
        for (let i = 0; i < scoreData?.exam_total_score.length; i++) {
          let { id, score } = scoreData?.exam_total_score[i];
          for (let j = 0; j < scoreData?.score_exam_usually.length; j++) {
            let { resource_id } = scoreData?.score_exam_usually[j];
            if (id == resource_id) {
              scoreData.score_exam_usually[j].full_score = score;
            }
          }
          for (let j = 0; j < scoreData?.score_exam_mid.length; j++) {
            let { resource_id } = scoreData?.score_exam_mid[j];
            if (id == resource_id) {
              scoreData.score_exam_mid[j].full_score = score;
            }
          }
          for (let j = 0; j < scoreData?.score_exam_final.length; j++) {
            let { resource_id } = scoreData?.score_exam_final[j];
            if (id == resource_id) {
              scoreData.score_exam_final[j].full_score = score;
            }
          }
          for (let j = 0; j < scoreData?.score_exam_other.length; j++) {
            let { resource_id } = scoreData?.score_exam_other[j];
            if (id == resource_id) {
              scoreData.score_exam_other[j].full_score = score;
            }
          }
        }
        // 获取平时表现分
        scoreData.usualPerformance = [...scoreData.score_exam_usually, ...scoreData.score_ext_active];
        if (scoreData.usualPerformance.length > 0) {
          scoreData.usualPerformance.forEach((item) => {
            let usualPerformanceNum = scoreData.usualPerformance.filter(({ user_id }) => user_id === item.user_id).length;
            item.percentage = (Number(item.score) / item.full_score) * (this.performancePercentage / usualPerformanceNum);
            studentTable[item.user_id].performanceScore += parseFloat(item.percentage.toFixed(1));
            studentTable[item.user_id].totalScore = studentTable[item.user_id].coursePoints + studentTable[item.user_id].performanceScore + studentTable[item.user_id].midtermExamScore + studentTable[item.user_id].finalExamScore + studentTable[item.user_id].otherExamScore;
          });
        }
        // 获取期中考试
        scoreData.midTermExamination = [...scoreData.score_exam_mid, ...scoreData.score_ext_middle];
        if (scoreData.midTermExamination.length > 0) {
          scoreData.midTermExamination.forEach((item) => {
            let midTermExaminationNum = scoreData.midTermExamination.filter(({ user_id }) => user_id === item.user_id).length;
            item.percentage = (Number(item.score) / item.full_score) * (this.proportionOfMidtermExams / midTermExaminationNum);
            studentTable[item.user_id].midtermExamScore += parseFloat(item.percentage.toFixed(1));
            studentTable[item.user_id].totalScore = studentTable[item.user_id].coursePoints + studentTable[item.user_id].performanceScore + studentTable[item.user_id].midtermExamScore + studentTable[item.user_id].finalExamScore + studentTable[item.user_id].otherExamScore;
          });
        }
        // 获取期末考试
        scoreData.finalExam = [...scoreData.score_exam_final, ...scoreData.score_ext_back];
        if (scoreData.finalExam.length > 0) {
          scoreData.finalExam.forEach((item) => {
            let finalExamNum = scoreData.finalExam.filter(({ user_id }) => user_id === item.user_id).length;
            item.percentage = (Number(item.score) / item.full_score) * (this.proportionOfFinalExams / finalExamNum);
            studentTable[item.user_id].finalExamScore += parseFloat(item.percentage.toFixed(1));
            studentTable[item.user_id].totalScore = studentTable[item.user_id].coursePoints + studentTable[item.user_id].performanceScore + studentTable[item.user_id].midtermExamScore + studentTable[item.user_id].finalExamScore + studentTable[item.user_id].otherExamScore;
          });
        }
        // 获取其他考试
        scoreData.otherExam = [...scoreData.score_exam_other];
        if (scoreData.otherExam.length > 0) {
          scoreData.otherExam.forEach((item) => {
            let otherExamNum = scoreData.otherExam.filter(({ user_id }) => user_id === item.user_id).length;
            item.percentage = (Number(item.score) / item.full_score) * (this.otherPercentage / otherExamNum);
            studentTable[item.user_id].otherExamScore += parseFloat(item.percentage.toFixed(1));
            studentTable[item.user_id].totalScore = studentTable[item.user_id].coursePoints + studentTable[item.user_id].performanceScore + studentTable[item.user_id].midtermExamScore + studentTable[item.user_id].finalExamScore + studentTable[item.user_id].otherExamScore;
          });
        }

        // 给学生表格数据赋值
        let studentDataList = [];
        for (let key in studentTable) {
          if (this.nameValue == "") {
            studentDataList.push(studentTable[key]);
          } else {
            if (this.nameValue == studentTable[key].name) {
              studentDataList.push(studentTable[key]);
              break;
            }
          }
        }
        let value1 = 0;
        let value2 = 0;
        let value3 = 0;
        let value4 = 0;
        let value5 = 0;
        let averageScore = 0;
        // 获取echart数据
        studentDataList.forEach(({ totalScore }) => {
          if (totalScore >= 0 && totalScore < 60) {
            value1++;
          } else if (totalScore >= 60 && totalScore < 70) {
            value2++;
          } else if (totalScore >= 70 && totalScore < 80) {
            value3++;
          } else if (totalScore >= 80 && totalScore < 90) {
            value4++;
          } else if (totalScore >= 90) {
            value5++;
          }
          // 计算平均分
          averageScore += totalScore;
        });
        this.averageScore = averageScore;
        this.preData[0].typeList[0].value = value1;
        this.preData[0].typeList[1].value = value2;
        this.preData[0].typeList[2].value = value3;
        this.preData[0].typeList[3].value = value4;
        this.preData[0].typeList[4].value = value5;
        this.preData[1].typeList[0].value = value1;
        this.preData[1].typeList[1].value = value2;
        this.preData[1].typeList[2].value = value3;
        this.preData[1].typeList[3].value = value4;
        this.preData[1].typeList[4].value = value5;
        // 计算及格率
        let passRate = this.roundFun(((value2 + value3 + value4 + value5) / studentList.length) * 100, 1);
        this.preData[0].countLength = "{totalText|平均分}" + "\n" + "{totalText|" + this.roundFun(this.averageScore / studentList.length, 1) + " 分}";
        this.preData[1].countLength = "{totalText|及格率}" + "\n" + "{totalText|" + passRate + " %}";
        this.studentDataList = studentDataList;
      });
    },
    // 班级选择器
    classHandleChange(value) {
      const arr = this.teachingClass.filter((item) => item.id === value[1]);
      this.currentGrade = arr[0].grade; // 获取当前年级
      this.currentClass = arr[0].name; // 获取当前班级
      this.preData[0].typeList[0].value = 0;
      this.preData[0].typeList[1].value = 0;
      this.preData[0].typeList[2].value = 0;
      this.preData[0].typeList[3].value = 0;
      this.preData[0].typeList[4].value = 0;
      this.preData[1].typeList[0].value = 0;
      this.preData[1].typeList[1].value = 0;
      this.preData[1].typeList[2].value = 0;
      this.preData[1].typeList[3].value = 0;
      this.preData[1].typeList[4].value = 0;
      this.averageScore = 0;
      this.preData[0].countLength = "{totalText|平均分}" + "\n" + "{totalText|" + 0 + "分}";
      this.preData[1].countLength = "{totalText|及格率}" + "\n" + "{totalText|" + 0 + "%}";
      this.classValue[1] = value[1]; // 获取班级id
      this.classId = value[1];
      // 调用获取表现分、期中考试分数、期末考试分数列表接口
      let params2 = { where: [{ k: "class_id", v: value[1], op: "=" }] };
      getScoreList(params2).then((res) => {
        if (res.data.code == 0) {
          this.scoreList = res.data.datas;
        }
      });
      this.nameValue = ""; // 重置默认姓名
      this.publicGettingDataFunc(); // 调用获取数据方法
    },
    // 日期选择器
    dateHandleChange(e) {
      this.publicGettingDataFunc(); // 调用获取数据方法
    },
    // 姓名选择器
    nameHandleChange(value) {
      this.nameValue = value; // 获取姓名
      this.publicGettingDataFunc(); // 调用获取数据方法
    },
    // 积分详情
    btnPointsDetails() {
      this.$router.push({
        name: "pointsDetails",
        params: { class: this.classValue },
      });
    },
    // 各分值占比设置
    btnPercentageOfPoints() {
      // 调用获取课程详情接口获取各分值占比设置
      let params = {
        where: [{ k: "id", v: this.$store.state.courseDetails.id, op: "=" }],
      };
      myCourseGet(params).then((res) => {
        this.proportionOfCoursePoints = res.data.datas.percent_lesson; // 获取课程积分占比
        this.performancePercentage = res.data.datas.percent_active; // 获取平时表现分占比
        this.proportionOfMidtermExams = res.data.datas.percent_middle; // 获取期中考试占比
        this.proportionOfFinalExams = res.data.datas.percent_back; // 获取期末考试占比
        this.otherPercentage = res.data.datas.percent_other; // 获取其他考试占比
      });
      this.showPercentageOfPoints = true;
    },
    // 各分支占比设置确定按钮
    btnConfirm() {
      let score1 = this.proportionOfCoursePoints; // 课程积分占比
      let score2 = this.performancePercentage; // 平时表现分占比
      let score3 = this.proportionOfMidtermExams; // 期中考试占比
      let score4 = this.proportionOfFinalExams; // 期末考试占比
      let score5 = this.otherPercentage; // 其他考试占比
      // 调用各分值占比设置接口
      if (score1 + score2 + score3 + score4 + score5 == 100) {
        let data = {
          lesson_id: this.$store.state.courseDetails.id,
          lesson: score1,
          active: score2,
          middle: score3,
          back: score4,
          other: score5,
        };
        scorePercentageSetting(data).then((res) => {
          if (res.data.code == 0) {
            this.showPercentageOfPoints = false;
          }
        });
        this.publicGettingDataFunc(); // 调用获取数据方法
      } else {
        Toast("各分支占比设置总值必须是100！");
      }

      // }
    },
    // 数据导出
    btnDataExport() {
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = ["学生名称", "学号", "年级", "班级", "课程积分", "平时表现分", "期中考试分数", "期末考试分数", "其他考试分数", "总评分"];
        const filterVal = ["name", "account", "grade", "class", "coursePoints", "performanceScore", "midtermExamScore", "finalExamScore", "otherExamScore", "totalScore"];
        const list = this.studentDataList;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          autoWidth: true,
          filename: "学生评分表",
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            import("@/vendor/Export2Excel").then((excel) => {
              return excel.parseTime(v[j]);
            });
          } else {
            return v[j];
          }
        })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
}

.main-content {
  width: 1740px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  overflow: scroll;
  padding: 30px 83px;
  box-sizing: border-box;
}

.selector-txt {
  margin-right: 13px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
}

// 各分值占比设置弹窗
.popup-percentageOfPoints {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.percentageOfPoints-content {
  position: relative;
  width: 900px;
  height: 329px;
  background: #ffffff;
  border-radius: 20px;
  padding: 0 50px 40px 50px;
  box-sizing: border-box;
}

.btnClose {
  position: absolute;
  top: 21px;
  right: 21px;
  width: 23px;
  height: 23px;
}

.percentageOfPoints-title {
  margin-top: 29px;
  font-size: 30px;

  font-weight: 400;
  color: #349afe;
  text-align: center;
}

.percentageOfPoints-setupBox {
  width: 200px;
  border: 1px solid #dddddd;
}

.percentageOfPoints-setupTitle {
  height: 43px;
  background: #eeeeee;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;

  font-weight: 400;
  color: #000000;
}

.percentageOfPoints-setup {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btnConfirm {
  width: 200px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;

  font-weight: 400;
  color: #ffffff;
}

.btnPointsDetails {
  width: 106px;
  height: 18px;
  margin-left: 20px;
  cursor: pointer;
}

.btnPercentageOfPoints {
  width: 169px;
  height: 18px;
  margin-left: 20px;
  cursor: pointer;
}

.btnDataExport {
  width: 107px;
  height: 19px;
  margin-left: 20px;
  cursor: pointer;
}

.percentageOfPoints-box {
  margin-top: 41px;
}
</style>
